import * as React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import moment from "moment";
import "./form.css";
import { basename } from "../../../../config";

export default function FieldDate(props) {
  const {
    label = "",
    className = "",
    value = null,
    onChange,
    error = false,
    errorMsg = ``,
    disableDate = false,
  } = props;

  return (
    <div className={`width100  muiTextDateField  ${className}`}>
      <LocalizationProvider dateAdapter={AdapterDateFns} error={error}>
        <MobileDatePicker
          label={label}
          // minDate={moment.now()}
          inputFormat="MM/dd/yyyy"
          disabled={disableDate}
          // InputProps={{ readOnly: disableDate }}
          value={value}
          onChange={onChange}
          renderInput={(params) => (
            <TextField
              className="muiTextField"
              size="small"
              {...params}
              error={error}
              helperText={errorMsg}
            />
          )}
        />
      </LocalizationProvider>
      <img src={`/${basename}/Assets/Images/calendar.png`} />
    </div>
  );
}
